export default Object.freeze({
    EUR: "€",
    GBP: "£",
    USD: "$",
    YEN: "¥",
})
